import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";
import { BACKEND_APIS } from "@constants";


export default function useCommonFiltersDefault(uniqueID, blockID) {
	const isLoading = useSignal(!!uniqueID && !!blockID)
	const filters = useSignal({})

	useEffect(() => {
		if (isLoading.value) {
			postSubmit(`${BACKEND_APIS.ADMIN}/user-default/filters`, {
				uniqueDashboard: uniqueID,
				dashboardBlock: blockID
			}).then(res => batch(() => {
				filters.value = res
				isLoading.value = false
			})).catch(() => {
				isLoading.value = false
			})
		}
	}, []);

	return {
		isLoadingDefaultFilters: isLoading.value,
		defaultFilters: filters.value
	}
}